// list of countries and regions supported by https://api.workingdays.org/1.2/api-documentation
export const countries = [
    { Name: 'None', Code: '00', Regions: [] },
    // {
    // 	Name: "Argentina",
    // 	Code: "AR",
    // 	Regions: [],
    // },
    // {
    // 	Name: "Australia",
    // 	Code: "Au",
    // 	Regions: [
    // 		"Australian Capital Territory",
    // 		"New South Wales",
    // 		"Northern Territory",
    // 		"Queensland",
    // 		"South Australia",
    // 		"Tasmania",
    // 		"Victoria",
    // 		"Western Australia",
    // 	],
    // },
    // {
    // 	Name: "Austria",
    // 	Code: "AT",
    // 	Regions: [
    // 		"Burgenland",
    // 		"Kärnten",
    // 		"Niederösterreich",
    // 		"Niederösterreich (private Unternehmen)",
    // 		"Oberösterreich",
    // 		"Salzburg",
    // 		"Steiermark",
    // 		"Tirol",
    // 		"Vorarlberg",
    // 		"Wien",
    // 		"Wien (private Unternehmen)",
    // 		"Wiener Börse",
    // 	],
    // },
    // {
    // 	Name: "Belgium",
    // 	Code: "BE",
    // 	Regions: ["Jours fériés nationaux", "Secteur public", "Bruxelles", "Communauté française", "Communauté flamande"],
    // },
    // {
    // 	Name: "Brasil",
    // 	Code: "BR",
    // 	Regions: [
    // 		"Feriados nacionais",
    // 		"Acre",
    // 		"Alagoas",
    // 		"Amapá",
    // 		"Amazonas",
    // 		"Bahia",
    // 		"Ceará",
    // 		"Distrito Federal",
    // 		"Espírito Santo",
    // 		"Goiás",
    // 		"Maranhão",
    // 		"Mato Grosso",
    // 		"Mato Grosso do Sul",
    // 		"Minas Gerais",
    // 		"Pará",
    // 		"Paraíba",
    // 		"Paraná",
    // 		"Pernambuco",
    // 		"Piauí",
    // 		"Rio de Janeiro",
    // 		"Rio Grande do Norte",
    // 		"Rio Grande do Sul",
    // 		"Rondônia",
    // 		"Roraima",
    // 		"Santa Catarina",
    // 		"São Paulo",
    // 		"Sergipe",
    // 		"Tocantins",
    // 	],
    // },
    // {
    // 	Name: "Bulgaria",
    // 	Code: "BG",
    // 	Regions: [],
    // },
    // {
    // 	Name: "Canada",
    // 	Code: "CA",
    // 	Regions: [
    // 		"Alberta",
    // 		"British Columbia",
    // 		"Manitoba",
    // 		"New Brunswick",
    // 		"Newfoundland and Labrador",
    // 		"Northwest Territories",
    // 		"Nova Scotia",
    // 		"Nunavut",
    // 		"Ontario",
    // 		"Prince Edward Island",
    // 		"Quebec",
    // 		"Saskatchewan",
    // 		"Yukon",
    // 		"Federal Holidays",
    // 		"Toronto Stock Exchange",
    // 	],
    // },
    // {
    // 	Name: "Chile",
    // 	Code: "CL",
    // 	Regions: [],
    // },
    // {
    // 	Name: "China",
    // 	Code: "CN",
    // 	Regions: [],
    // },
    // {
    // 	Name: "Colombia",
    // 	Code: "CO",
    // 	Regions: [],
    // },
    // {
    // 	Name: "Czech Republic",
    // 	Code: "CZ",
    // 	Regions: [],
    // },
    // {
    // 	Name: "Denmark",
    // 	Code: "DK",
    // 	Regions: [],
    // },
    // {
    // 	Name: "Germany",
    // 	Code: "DE",
    // 	Regions: [
    // 		"Gesetzliche Feiertage",
    // 		"Baden-Württemberg",
    // 		"Bayern",
    // 		"Berlin",
    // 		"Brandenburg",
    // 		"Bremen",
    // 		"Hamburg",
    // 		"Hessen",
    // 		"Mecklenburg-Vorpommern",
    // 		"Niedersachsen",
    // 		"Nordrhein-Westfalen",
    // 		"Rheinland-Pfalz",
    // 		"Saarland",
    // 		"Sachsen",
    // 		"Sachsen-Anhalt",
    // 		"Schleswig-Holstein",
    // 		"Thüringen",
    // 		"Börse Frankfurt",
    // 	],
    // },
    // {
    // 	Name: "Spain",
    // 	Code: "ES",
    // 	Regions: [
    // 		"Festivos nacionales",
    // 		"Andalucía",
    // 		"Aragón",
    // 		"Principado de Asturias",
    // 		"Islas Baleares",
    // 		"Islas Canarias",
    // 		"Cantabria",
    // 		"Castilla y León",
    // 		"Castilla-La Mancha",
    // 		"Cataluña",
    // 		"Ciudad de Ceuta",
    // 		"País Vasco",
    // 		"Extremadura",
    // 		"Galicia",
    // 		"Comunidad de Madrid",
    // 		"Ciudad de Melilla",
    // 		"Región de Murcia",
    // 		"Comunidad Foral de Navarra",
    // 		"Comunidad Valenciana",
    // 		"La Rioja",
    // 	],
    // },
    // {
    // 	Name: "Finland",
    // 	Code: "FI",
    // 	Regions: [],
    // },
    // {
    // 	Name: "France",
    // 	Code: "FR",
    // 	Regions: ["Calendrier civil", "Bas-Rhin, Haut-Rhin, Moselle", "Guadeloupe", "Guyane", "Martinique", "Réunion", "Calendrier boursier (Euronext Paris)"],
    // },
    // {
    // 	Name: "Greece",
    // 	Code: "GR",
    // 	Regions: [],
    // },
    // {
    // 	Name: "Hong-Kong",
    // 	Code: "HK",
    // 	Regions: [],
    // },
    // {
    // 	Name: "Hungary",
    // 	Code: "HU",
    // 	Regions: [],
    // },
    // {
    // 	Name: "India",
    // 	Code: "IN",
    // 	Regions: [],
    // },
    // {
    // 	Name: "Israel",
    // 	Code: "IL",
    // 	Regions: [],
    // },
    // {
    // 	Name: "Italy",
    // 	Code: "IT",
    // 	Regions: ["Giorni festivi nazionali", "Florence", "Genoa", "Torino", "Milano", "Napoli", "Roma", "Sardigna"],
    // },
    // {
    // 	Name: "Japan",
    // 	Code: "JP",
    // 	Regions: [],
    // },
    // {
    // 	Name: "Luxembourg",
    // 	Code: "LU",
    // 	Regions: ["Calendrier civil usuel", "Calendrier bancaire"],
    // },
    // {
    // 	Name: "Monaco",
    // 	Code: "MC",
    // 	Regions: [],
    // },
    // {
    // 	Name: "Mexico",
    // 	Code: "MX",
    // 	Regions: [],
    // },
    // {
    // 	Name: "Netherlands",
    // 	Code: "NL",
    // 	Regions: ["National holidays", "Public sector"],
    // },
    // {
    // 	Name: "New Zealand",
    // 	Code: "NZ",
    // 	Regions: [
    // 		"National public holidays",
    // 		"Auckland",
    // 		"Canterbury",
    // 		"Canterbury South",
    // 		"Chatham Islands",
    // 		"Hawke’s Bay",
    // 		"Marlborough",
    // 		"Nelson",
    // 		"Otago",
    // 		"Southland",
    // 		"Taranaki",
    // 		"Wellington",
    // 		"Westland",
    // 	],
    // },
    // {
    // 	Name: "Norway",
    // 	Code: "NO",
    // 	Regions: [],
    // },
    // {
    // 	Name: "Peru",
    // 	Code: "PE",
    // 	Regions: [],
    // },
    // {
    // 	Name: "Poland",
    // 	Code: "PL",
    // 	Regions: [],
    // },
    // {
    // 	Name: "Portugal",
    // 	Code: "PT",
    // 	Regions: ["Feriados Nacionais", "Açores", "Lisboa", "Madeira", "Porto", "Sintra"],
    // },
    // {
    // 	Name: "Romania",
    // 	Code: "RO",
    // 	Regions: [],
    // },
    // {
    // 	Name: "Russia",
    // 	Code: "RU",
    // 	Regions: [],
    // },
    // {
    // 	Name: "Singapore",
    // 	Code: "SG",
    // 	Regions: [],
    // },
    // {
    // 	Name: "Slovakia",
    // 	Code: "SK",
    // 	Regions: [],
    // },
    // {
    // 	Name: "South Africa",
    // 	Code: "ZA",
    // 	Regions: [],
    // },
    // {
    // 	Name: "Switzerland",
    // 	Code: "CH",
    // 	Regions: [
    // 		"Aargau",
    // 		"Aargau (Aarau, Brugg, Kulm, Lenzburg, Zofingen Baden)",
    // 		"Aargau (Baden)",
    // 		"Aargau (Bremgarten)",
    // 		"Aargau (Laufenburg, Muri, Rheinfelden)",
    // 		"Aargau (Rheinfelden)",
    // 		"Aargau (Zurzach)",
    // 		"Appenzell Ausserrhoden",
    // 		"Appenzell Innerrhoden",
    // 		"Basel-Landschaft",
    // 		"Basel-Stadt",
    // 		"Bern",
    // 		"Freiburg",
    // 		"Freiburg (katholisch)",
    // 		"Freiburg (reformiert)",
    // 		"Genf",
    // 		"Glarus",
    // 		"Graubünden",
    // 		"Jura",
    // 		"Luzern",
    // 		"Neuenburg",
    // 		"Nidwalden",
    // 		"Obwalden",
    // 		"Sankt Gallen",
    // 		"Schaffhausen",
    // 		"Schwyz",
    // 		"Solothurn",
    // 		"Tessin",
    // 		"Thurgau",
    // 		"Uri",
    // 		"Wallis",
    // 		"Waadt",
    // 		"Zug",
    // 		"Zürich",
    // 		"Zürich (Stadt)",
    // 		"Zürich Börse",
    // 	],
    // },
    // {
    // 	Name: "Sweden",
    // 	Code: "SE",
    // 	Regions: [],
    // },
    // {
    // 	Name: "Turkey",
    // 	Code: "TR",
    // 	Regions: [],
    // },
    // {
    // 	Name: "USA",
    // 	Code: "US",
    // 	Regions: [
    // 		"Federal holidays",
    // 		"Alabama",
    // 		"Alaska",
    // 		"Arizona",
    // 		"Arkansas",
    // 		"California",
    // 		"Colorado",
    // 		"Connecticut",
    // 		"Delaware",
    // 		"District of Columbia",
    // 		"Florida",
    // 		"Georgia",
    // 		"Hawaii",
    // 		"Idaho",
    // 		"Illinois",
    // 		"Indiana",
    // 		"Iowa",
    // 		"Kansas",
    // 		"Kentucky",
    // 		"Louisiana",
    // 		"Maine",
    // 		"Maryland",
    // 		"Massachusetts",
    // 		"Michigan",
    // 		"Minnesota",
    // 		"Mississippi",
    // 		"Missouri",
    // 		"Montana",
    // 		"Nebraska",
    // 		"Nevada",
    // 		"New Hampshire",
    // 		"New Jersey",
    // 		"New Mexico",
    // 		"New York",
    // 		"New York Sto",
    // 		"North Carolina",
    // 		"North Dakota",
    // 		"Ohio",
    // 		"Oklahoma",
    // 		"Oregon",
    // 		"Pennsylvania",
    // 		"Rhode Island",
    // 		"South Carolina",
    // 		"South Dakota",
    // 		"Tennessee",
    // 		"Texas",
    // 		"Utah",
    // 		"Vermont",
    // 		"Virginia",
    // 		"Washington",
    // 		"West Virginia",
    // 		"Wisconsin",
    // 		"Wyoming",
    // 	],
    // },
    // {
    // 	Name: "Ukraine",
    // 	Code: "UA",
    // 	Regions: [],
    // },
    {
        Name: 'United Kingdom & Ireland',
        Code: 'GB',
        Regions: ['England', 'Scotland', 'Northern Ireland', 'Ireland', 'Wales'],
    },
    // {
    // 	Name: "Venezuela",
    // 	Code: "VE",
    // 	Regions: [],
    // },
];
